
import React from 'react';
import './rulesOfSite.css';

const RulesOfSite = () => {
  return (
    <div className="rules-of-site-container">
      <h1>Правила работы сайта</h1>

      <p>
        Настоящие правила составлены с учетом законодательства РФ и не являются рекламой табачной продукции. Сайт является платформой Продавца табачной продукции, который осуществляет продажи удаленно. Сайт создан для информирования Клиентов об ассортименте и удобного оформления заказов с целью оптимизации обслуживания.
      </p>

      <h2>Стороны настоящего Соглашения</h2>
      <p>
        <strong>Клиент</strong> — физическое лицо, имеющее намерение оформить и/или оформляющее заказы на сайте, и обладающее необходимым объемом дееспособности в соответствии с законодательством РФ.
      </p>
      <p>
        <strong>Продавец</strong> — ИП Кудишкин А.В., осуществляющий продажу табачных изделий.
      </p>

      <h2>Термины</h2>
      <p>
        <strong>Заказ</strong> — должным образом оформленный запрос Клиента на приобретение табачной продукции, который Клиент желает оформить через сайт. Заказ служит для получения Клиентом информации о цене и наличии товара, а также для инициирования сделки купли-продажи.
      </p>

      <h2>1. Общие положения</h2>
      <p>
        Представленная на сайте продукция предназначена для ознакомления с ассортиментом и заказа табачной продукции с возможностью удаленной доставки. Направляя заказы через сайт, Клиент соглашается с Правилами сайта (далее — Условия), изложенными ниже. Настоящее соглашение, представленное на Сайте, является публичной офертой в соответствии со ст. 435 и ч. 2 ст. 437 ГК РФ. Также Продавец оставляет за собой право вносить изменения в это Соглашение.
      </p>

      <h2>2. Оформление Заказа</h2>
      <p>
        Заказ Клиента оформляется самостоятельно на сайте. Клиент заполняет регистрационную форму и соглашается с условиями настоящей оферты. Заказ может быть оформлен также по телефону. Продавец оставляет за собой право отказать Клиенту в регистрации на сайте без объяснения причин.
      </p>

      <h2>3. Сроки подтверждения Заказа</h2>
      <p>
        После оформления Заказа Клиент получает на указанный им электронный адрес информацию о точной стоимости товара и контактные данные Продавца. В течение 2-х дней с момента получения Заказа представитель Продавца может связываться с Клиентом для получения уточненной информации. Клиент может оформить доверенность на представителя для совершения сделки купли-продажи.
      </p>

      <h2>4. Приобретение Товара и переход права собственности на Товар</h2>
      <p>
        Информация о цене и ассортименте товара, размещенная на сайте, служит для информирования Клиентов. Сделки по приобретению товара могут быть завершены удаленно с учетом предварительного согласия Клиента.
      </p>

      <h2>5. Оплата товара</h2>
      <p>
        Цена товара на сайте может быть изменена Продавцом. Оплата может производиться удаленно с помощью банковской карты. При полном или частичном отказе от товара средства возвращаются клиенту в соответствии с внутренними правилами Продавца.
      </p>

      <h2>6. Информация, предоставляемая Клиентом</h2>
      <p>
        При оформлении Заказа Клиент предоставляет информацию, необходимую для обработки и выполнения заказа. Продавец использует предоставленную информацию в соответствии с законодательством и с согласия Клиента.
      </p>

      <p><em>* Если иное не указано в информации о товаре.</em></p>
    </div>
  );
};

export default RulesOfSite;
